import { useState } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import { Close, ImageSearch } from '@mui/icons-material';

interface Props {
  title: string;
  image: string;
  /** Optional second figure shown below the first (e.g. worked examples). */
  secondaryImage?: string;
  secondaryTitle?: string;
}

/**
 * Clickable reference-figure affordance (REQ-02/08/09): a small icon button
 * that opens the embedded diagram in a dialog. Figures are extracted from the
 * KeyLAB workbook (specs/reference-figures/).
 */
export const ReferenceFigureButton = ({ title, image, secondaryImage, secondaryTitle }: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Tooltip title={`Reference figure: ${title}`}>
        <IconButton size="small" onClick={() => setOpen(true)} sx={{ p: 0.25, color: 'primary.main' }}>
          <ImageSearch sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
        <DialogTitle sx={{ fontSize: '0.95rem', fontWeight: 700, pr: 6 }}>
          {title}
          <IconButton
            size="small"
            onClick={() => setOpen(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box component="img" src={image} alt={title} sx={{ maxWidth: '100%', display: 'block', mx: 'auto' }} />
          {secondaryImage && (
            <>
              {secondaryTitle && (
                <Box sx={{ fontSize: '0.8rem', fontWeight: 600, mt: 2, mb: 0.5 }}>{secondaryTitle}</Box>
              )}
              <Box
                component="img"
                src={secondaryImage}
                alt={secondaryTitle ?? title}
                sx={{ maxWidth: '100%', display: 'block', mx: 'auto', mt: secondaryTitle ? 0 : 2 }}
              />
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
